import { ActiveMonthContext } from "../components/layout/layout"
import { useCallback, useContext } from "react"
import getDefaultMonthIndex from "../services/getDefaultMonthIndex";
import { monthSlugs } from "../services/centralStore";
import { useDispatch } from "react-redux";
import { setMonth as setMonthAction } from '../store/weatherSearchSlice';

export const useMonth = ({ ignoreOverview }: { ignoreOverview?: boolean }) => {

    const dispatch = useDispatch();
    const [month, setMonth] = useContext(ActiveMonthContext);
    if (!month) {
        setMonth(monthSlugs[getDefaultMonthIndex()]);
    }
    let activeMonth = month;
    if (ignoreOverview && month == 'climate') {
        activeMonth = monthSlugs[getDefaultMonthIndex()];
    }
    const setMonthComplete = useCallback((m: string) => {
        dispatch(setMonthAction(m));
        setMonth(m);
    }, [setMonth])
    return { month: activeMonth, setMonth: setMonthComplete };
}